import React from 'react'

import { IIcons } from './types'

import { GreyLighten47 } from '@/const/colors'

export default (props: IIcons) => {
  const { style, fill = GreyLighten47 } = props
  const defaultStyle = { width: 24, height: 24 }

  return (
    <svg style={{ ...defaultStyle, ...style }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_4626_979"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.46444 20.535C4.92889 22 7.28556 22 12 22C16.7133 22 19.0711 21.999 20.5356 20.535C22 19.071 22 16.714 22 12C22 7.286 22 4.93 20.5356 3.464C19.0711 2 16.7133 2 12 2L11.9904 2C7.28345 2 4.92789 2 3.46444 3.464C2 4.929 2 7.286 2 12C2 16.714 2 19.072 3.46444 20.535ZM14.696 15.0585C14.918 15.2769 15.2786 15.2769 15.5006 15.0585L17.8325 12.7645C18.0545 12.5461 18.0545 12.1924 17.8325 11.974L15.5006 9.67996L15.4109 9.60856C15.1903 9.46539 14.8902 9.48895 14.696 9.67996C14.5017 9.87096 14.4778 10.166 14.6234 10.383L14.696 10.4712L16.6264 12.3688L14.696 14.2681C14.4743 14.4864 14.4742 14.8402 14.696 15.0585ZM12.9767 8.35947C13.2812 8.43433 13.4668 8.73792 13.3909 9.03735L11.6416 15.9187C11.5655 16.2181 11.2568 16.4007 10.9523 16.3261C10.6478 16.2512 10.4621 15.9476 10.538 15.6482L12.2874 8.76687C12.3635 8.46744 12.6722 8.28484 12.9767 8.35947ZM9.30186 9.60856C9.10751 9.41769 8.80751 9.39377 8.58692 9.53716L8.49808 9.60856L6.16533 11.9026C5.94354 12.1209 5.94363 12.4747 6.16533 12.6931L8.49808 14.9871L8.58692 15.0585C8.80758 15.202 9.10747 15.1781 9.30186 14.9871C9.49611 14.7961 9.52096 14.501 9.37532 14.284L9.30186 14.1967L7.37143 12.2974L9.30186 10.3998C9.52389 10.1815 9.52389 9.8269 9.30186 9.60856Z"
          fill={fill}
        />
      </mask>
      <g mask="url(#mask0_4626_979)">
        <rect width="24" height="24" fill={fill} />
      </g>
    </svg>
  )
}
